export default "__VITE_ASSET__y0mAseg9__"